import React, { useEffect, useState } from "react";
import PiecePerduDesktop from "./PiecePerduDesktop";
import PiecePerduMobile from "./PiecePerduMobile";

const detectMobile = () => {
  if (typeof navigator !== "undefined" && navigator.userAgent) {
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return true;
    }
  }

  if (typeof window !== "undefined") {
    return window.innerWidth <= 900;
  }

  return false;
};

const PiecePerdu = () => {
  const [isMobile, setIsMobile] = useState(() => detectMobile());

  useEffect(() => {
    const onResize = () => setIsMobile(detectMobile());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isMobile ? <PiecePerduMobile /> : <PiecePerduDesktop />;
};

export default PiecePerdu;
